import { formatCurrencyValue } from "../../../util/PaymentUtils";
import { formatFrequency } from "@securspace/securspace-ui-kit";
import { assetTypeOptions, frequencyOptions, BookingStatusGroups } from "../data";
import moment from "moment";

const sortByFields = [
  {label: "Booking Number", value: "ORDER_NUMBER"},
  {label: "Supplier", value: "SUPPLIER_COMPANY_NAME"},
  {label: "Start Date", value: "START_DATE"}
];

const filterBySelectOption = [
  {
    label: "Equipment Type",
    value: "",
    name: "equipmentType",
    option: assetTypeOptions
  },
  {
    label: "Frequency",
    value: "",
    name: "frequency",
    option: frequencyOptions
  }
];

const buyerHeaderCells = [
  { id: 'orderNumber', label: 'BOOKING NUMBER' },
  { id: 'frequencyValue', label: 'FREQUENCY' },
  { id: 'bookedDates', label: 'BOOKED DATES' },
  { id: 'locationName', label: 'LOCATION' },
  { id: 'recurringCharge', label: 'MONTHLY CHARGE' },
  { id: 'status', label: 'STATUS' },
  { id: 'supplierCompanyName', label: 'SUPPLIER' },
  { id: 'numberOfSpaces', label: 'SPACES BOOKED' },
  { id: 'paymentSchedule', label: 'PAYMENT SCHEDULE' },
  { id: 'initialCharge', label: 'INITIAL CHARGE' },
  { id: 'paymentMethodDescription', label: 'PAYMENT METHOD' },
  { id: 'assetType', label: 'EQUIPMENT TYPE' },
  { id: 'createdOn', label: 'CREATED ON' },
  { id: 'rate', label: 'RATE' },
  { id: 'overageRate', label: 'OVERAGE RATE' },
];

const showEndDate = (data) => {
  const {endDateAdjusted, bookingSubscriptionStatus, frequency} = data;
  const CANCELLED = 'CANCELLED';
  const RECURRING = 'RECURRING';

  const isOneTime = frequency !== RECURRING;
  const isCancelled = bookingSubscriptionStatus === CANCELLED;

  return (
      isCancelled ||
      isOneTime  ||
      (endDateAdjusted === true)
  );
};

const rateFrequencyLabel = Object.freeze({
  DAILY: "Day",
  WEEKLY: "Week",
  MONTHLY: "Month"
});

function formatRateField(booking) {
  return rateFrequencyLabel[booking?.durationType] ? `${formatCurrencyValue(booking.rate, true)}/${rateFrequencyLabel[booking?.durationType]}` : '';
};

function formatOverageRateField(booking) {
  if (booking?.chargeOverages && booking?.locationChargeOverages) {
    if (booking.brokered) {
      return formatCurrencyValue(booking.brokeredBuyerOverageRateCharged, true);
    } else {
      return formatCurrencyValue(booking.locationOverageRate, true);
    }
  }

  return '';
};

const transformBooking = (booking) => {
  const commonProperties = {
    bookingTitle: booking.locationName ? `${booking.locationName} - ${booking.supplierCompanyName}` : booking.supplierCompanyName,
    initialCharge: formatCurrencyValue(booking.initialCharge, true),
    recurringCharge: formatCurrencyValue(booking.recurringCharge, true),
    rate: formatRateField(booking),
    overageRate: formatOverageRateField(booking),
    frequencyValue: formatFrequency(booking.frequency, booking.durationType),
    bookedDates: `${moment(booking.startDate).format("MM/DD/YYYY") || "N/A"} → ${showEndDate(booking) ? moment(booking.endDate).format("MM/DD/YYYY") : 'Until cancelled'}`
  };

  return {
    ...booking,
    ...commonProperties
  };
};

const BuyerBookingTabs = Object.freeze({
  ACTIVE: BookingStatusGroups.ACTIVE,
  PENDING: BookingStatusGroups.PENDING,
  INACTIVE: BookingStatusGroups.INACTIVE,
  FAILED: BookingStatusGroups.FAILED,
});

export {
    sortByFields,
    buyerHeaderCells,
    filterBySelectOption,
    transformBooking,
    BuyerBookingTabs
}